import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import './CompareModal.scss'

@inject('auth') @observer
export default class CompareModal extends Component {

  renderResultGender = (gender) => {
    const {  auth: { pushAuth } } = this.props
    if (!pushAuth.showPgsGender) {
      return <li className='resultDetailText'>XN</li>
    }
    if (gender !== '' && gender !== undefined) {
      return (
        <li className='resultDetailText'>
          {gender}
        </li>
      )
    } else {
      return ''
    }
  }

  renderResultAneu = (aneu) => {
    if (aneu !== '' && aneu !== undefined) {
      const resultAneu = aneu.split(';').join('; ').split(' ')
      return (
        resultAneu.map((item, index) => {
          if (item !== '') {
            return (
              <li key={index} className='resultDetailText'>
                {item}
              </li>
            )
          } else {
            return null
          }
        })
      )
    } else {
      return (
        <li className='resultDetailText'>未见异常</li>
      )
    }
  }

  renderResultCNV = (cnv) => {
    if (cnv !== '' && cnv !== undefined) {
      const resultCNV = cnv.split(';').join('; ').split(' ')
      return (
        resultCNV.map((item, index) => {
          if (item !== '') {
            return (
              <li key={index} className='resultDetailText'>
                {item}
              </li>
            )
          } else {
            return null
          }
        })
      )
    } else {
      return (
        <li className='resultDetailText'>未见异常</li>
      )
    }
  }
  
  renderResultMany = (detailData) => {
    if (
      detailData.ployStatistical !== "" &&
      detailData.ployStatistical !== undefined &&
      detailData.ployStatistical !== null &&
      (detailData.ployStatistical.Ploidy || detailData.ployStatistical.Zscore)
    ) {
      return (
        <li className="resultDetailText">
          {detailData.ployStatistical.Ploidy}
          {detailData.ployStatistical.Zscore!=='NA'?'('+detailData.ployStatistical.Zscore+')':''}
        </li>
      )
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultROH = (detailData) => {
    if (
      detailData.rohStatistical !== "" &&
      detailData.rohStatistical !== undefined &&
      detailData.rohStatistical !== null &&
      detailData.rohStatistical.ROHResult
    ) {
      if (detailData.rohStatistical.ROHResult !== "无法判断") {
        const ROHResult = detailData.rohStatistical.ROHResult.split(";").join("; ").split(" ")
        return ROHResult.map((item, index) => {
          if (item !== "") {
            // if(item.indexOf('UPD')>0){
            //   return (
            //     <li key={index} className="resultDetailText Text-weight">
            //       {item}
            //     </li>
            //   )
            // }else{
              return (
                <li key={index} className="resultDetailText">
                  {item}
                </li>
              )
            // }
           
          } else {
            return null
          }
        })
      } else {
        return <li className="resultDetailText">无法判断</li>
      } 
    } else {
      return <li className="resultDetailText">未见异常</li>
    }
  }

  renderResultM = (result) => {
    if (result !== '' && result !== undefined) {
      return (
        <li className='resultDetailText'>{result}</li>
      )
    } else {
      return <li className='resultDetailText'>无</li>
    }
  }

  render() {
    let { data = {},closeModal, detailData } = this.props
    const userInfo = this.props.auth.userInfo
    return (
      <MaterialModal
        wrapClassName='compare-modal-wrap'
        draggable={true}
        className="compare-modal"
        title="报告结果对比"
        visible={true}
        width={1100}
        mask={false}
        footer={false}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => {
            closeModal('compareModalShowed')
          }}
        />
        <div className="compareWrap">
          <div className="result-left">
            <div className="sub-title">报告结果</div>
            <div className='reportResultWrap'>
              <ul>
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '结果' : '性染色体' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultGender(detailData.resultGender)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '嵌合' : '整倍体' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultAneu(detailData.resultAneu)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '小CNV' : 'CNV' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultCNV(detailData.resultCNV)}
                  </ul>
                </li>
                {userInfo.id === "25" ?
                    <li>
                      <div className='reportResultTitle'>遗传解读</div>
                      <ul className='resultDetailList'>
                        {this.renderResultM(detailData.resultAdvice)}
                      </ul>
                    </li>
                 :''}
                    {(data.appName).indexOf('plus') >-1 ? 
                      <li>
                        <div className='reportResultTitle'>三倍体(异源)</div>
                        <ul className='resultDetailList'>
                        {this.renderResultMany(detailData)}
                        </ul>
                      </li>
                    :''
                    }
                    {(data.appName).indexOf('plus') >-1 ? 
                      <li>
                        <div className='reportResultTitle'>ROH</div>
                        <ul className='resultDetailList'>
                        {this.renderResultROH(detailData)}
                        </ul>
                      </li>
                    :''
                    }
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '备注' : '补充结果' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultM(detailData.resultM)}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="result-right">
            <div className="sub-title">审核结果</div>
            <div className='reportResultWrap'>
              <ul>
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '结果' : '性染色体' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultGender(detailData.summaryGender)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '嵌合' : '整倍体' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultAneu(detailData.summaryAneu)}
                  </ul>
                </li>
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '小CNV' : 'CNV' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultCNV(detailData.summaryCNV)}
                  </ul>
                </li>
                {userInfo.id === "25" ?
                    <li>
                      <div className='reportResultTitle'>遗传解读</div>
                      <ul className='resultDetailList'>
                        {this.renderResultM(detailData.summaryAdvice)}
                      </ul>
                    </li>
                :''}
                    {(data.appName).indexOf('plus') >-1 ? 
                      <li>
                        <div className='reportResultTitle'>三倍体(异源)</div>
                        <ul className='resultDetailList'>
                        {this.renderResultM(detailData.summaryPloidy)}
                        </ul>
                      </li>
                      :''
                    }
                    {(data.appName).indexOf('plus') >-1 ? 
                      <li>
                        <div className='reportResultTitle'>ROH</div>
                        <ul className='resultDetailList'>
                        {this.renderResultM(detailData.summaryRoh)}
                        </ul>
                      </li>
                    :''
                    }
                <li>
                  <div className='reportResultTitle'>{userInfo.id === "25" ? '备注' : '补充结果' }</div>
                  <ul className='resultDetailList'>
                    {this.renderResultM(detailData.summary)}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/CompareModal.js